/**
 * Chrome-less field shared by the inline `Input` and the ghost `Select.Input`.
 * Apply only while valid and enabled so the danger/disabled border still shows.
 */
export const ghostFieldClasses = [
  'interactive relative w-fit max-w-full rounded-md bg-transparent border-0 shadow-none',
  'hover:border-0',
  // Inner input has outline-none, so ring the container. Matches the ghost
  // Button: subtle outer ring + 0.5px inset border (explicit-length outer so
  // tailwind-merge drops the base teal ring; inset color swaps in dark mode).
  'focus-within:border-0',
  'focus-within:shadow-[0_0_0_2.5px_var(--color-shadow-focus-ring-subtle),0_0_0_0.5px_var(--color-border-button-secondary-inset)_inset]',
  'dark:focus-within:shadow-[0_0_0_2.5px_var(--color-shadow-focus-ring-subtle),0_0_0_0.5px_var(--color-border-button-secondary-top)_inset]',
]

// Shrinkable (with the container's `max-w-full`) so a narrow parent clips the text, not the right section.
export const ghostFieldInputClasses =
  'w-auto flex-initial min-w-0 [field-sizing:content]'
